import { Component, Input } from '@angular/core';

@Component({
	selector: 'rev-loading-overlay',
	templateUrl: './loading-overlay.component.html',
	styles: [],
	standalone: false,
})
export class LoadingOverlayComponent {

	@Input()
	loading: boolean;

	constructor() {
	}
}
